import React, { Component } from 'react';

class AddressList extends Component {
    getAddressPreview(address) {
        const addressType = address.user_address_type || address.address_type || '';
        const typeLabel = addressType === 'W' || addressType === 'Work' ? 'Work' : 'Home';
        const lineOne = address.user_address || address.address_line_1 || '';
        const lineTwo = address.user_locality || address.locality || address.address_line_2 || '';
        const city = address.user_city || address.city || '';
        const state = address.user_state || address.state || '';
        const landmark = address.user_landmark || address.landmark || '';
        const postalCode = address.user_pincode || address.postal_code || '';

        return {
            id: address.address_id || address.id,
            name: address.user_name || address.name || '-',
            mobile: address.user_mobile || address.mobile || '-',
            typeLabel,
            firstLine: [lineOne, lineTwo, city].filter(Boolean).join(', '),
            secondLine: [state, landmark, postalCode].filter(Boolean).join(', '),
        };
    }

    render() {
        const { addressList = [], loading = false, defaultUpdatingId, deletingId, onEditAddress, onSetDefault, onDeleteAddress } = this.props;
        if (loading) {
            return (
                <div className="ps-address-list ps-address-list--loading" role="status" aria-busy="true" aria-label="Loading saved addresses">
                    {[1, 2].map((item) => (
                        <div className="ps-address-list__skeleton" key={item}>
                            <span className="ps-address-list__skeletonLine ps-address-list__skeletonLine--short" />
                            <span className="ps-address-list__skeletonLine" />
                            <span className="ps-address-list__skeletonLine ps-address-list__skeletonLine--wide" />
                        </div>
                    ))}
                </div>
            );
        }
        return (
            <div className="ps-address-list">
                    {addressList.length>0 ?
                        addressList.map((data)=>{
                            const preview = this.getAddressPreview(data);
                            return(
                                <article className={`ps-address-list__item${data.is_default ? ' ps-address-list__item--default' : ''}`} key={preview.id} aria-label={`${preview.name}, ${preview.typeLabel} address`}>
                                    <div className="ps-address-list__itemHeader">
                                        <div className="ps-address-list__badges">
                                        <span className="ps-address-list__type">{preview.typeLabel}</span>
                                        {data.is_default && <span className="ps-address-list__defaultBadge">Default delivery</span>}
                                        </div>
                                        <div className="ps-address-list__actions">
                                            {!data.is_default && (
                                                <button
                                                    type="button"
                                                    className="ps-address-list__defaultButton"
                                                    disabled={defaultUpdatingId === preview.id}
                                                    onClick={() => onSetDefault && onSetDefault(data)}
                                                >
                                                    {defaultUpdatingId === preview.id ? 'Updating…' : 'Make default'}
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                className="ps-address-list__editButton"
                                                onClick={() => onEditAddress && onEditAddress(data)}
                                            >
                                                <span>Edit</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="ps-address-list__deleteButton"
                                                disabled={deletingId === preview.id}
                                                onClick={() => onDeleteAddress && onDeleteAddress(data)}
                                            >
                                                {deletingId === preview.id ? 'Deleting…' : 'Delete'}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="ps-address-list__meta">
                                        <strong>{preview.name}</strong>
                                        <span>{preview.mobile}</span>
                                    </div>
                                    <div className="ps-address-list__body">
                                        <p>{preview.firstLine || '-'}</p>
                                        <p>{preview.secondLine || '-'}</p>
                                    </div>
                                </article>
                            );
                        })
                    :
                        <div className="ps-address-list__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true"><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2.5"/></svg><h3>No saved addresses yet</h3><p>Add your first address to make checkout a little easier.</p></div>
                    }
            </div>
        );
    }
}

export default AddressList;
